import { deviceTypes } from './data_types'
import { FormattedDevice, FormattedDeviceMetric } from './types'

export const EMPTY_FORMATTED_DEVICE_METRIC: FormattedDeviceMetric<any> = {
  value: 0,
  display: '0',
  label: 'Unknown',
  statusType: 'none'
}

export const EMPTY_FORMATTED_DEVICE: FormattedDevice = {
  id: '',
  productName: 'Unknown',
  type: deviceTypes.items.unknown,
  chargingState: 'notCharging',

  metrics: {
    isInPlay: EMPTY_FORMATTED_DEVICE_METRIC,
    inPitch: EMPTY_FORMATTED_DEVICE_METRIC,
    battery: EMPTY_FORMATTED_DEVICE_METRIC,
    status: EMPTY_FORMATTED_DEVICE_METRIC,
    positionDataRate: EMPTY_FORMATTED_DEVICE_METRIC,
    accelerationStdDev: EMPTY_FORMATTED_DEVICE_METRIC,
    positionHealth: EMPTY_FORMATTED_DEVICE_METRIC,
    rangingQuality: EMPTY_FORMATTED_DEVICE_METRIC,
    networkQuality: EMPTY_FORMATTED_DEVICE_METRIC,
    imuQuality: EMPTY_FORMATTED_DEVICE_METRIC,
    imuLength: EMPTY_FORMATTED_DEVICE_METRIC,
    temperature: EMPTY_FORMATTED_DEVICE_METRIC
  },

  rssi: {},
  distance: {},
  count: {},

  slowSensor: {
    appUptime: 0,
    avgCurrent: 0,
    battery: 0,
    deviceId: 0,
    dwTemp: 0,
    mcuTemp: 0,
    state: {
      machine: 'unknown',
      state: 'unknown'
    },
    timestamp: Date.now(),
    uwbRole: 'unknown',
    uwbUptime: 0,
    voltage: 0
  },

  master: false,
  greyListed: false,
  position: { x: 0, y: 0, z: 0 },
  masterSignalStrength: -100,
  lastOnline: Date.now(),
  state: 'unknown',
  seatState: 'unknown',
  inSession: false,
  distanceToMaster: -1,
  hasFluctuated: false,

  appFwVersion: '',
  uwbFwVersion: ''
}
